import { useContext, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import _ from "lodash"

import { api } from "../../api/api"
import { NavBar } from "../../components/NavBar"
import { FiBox, FiEdit2, FiPlus, FiSearch, FiTrash2, FiZap } from "react-icons/fi"
import { ProductModal } from "../../components/Modals/Product"
import { ProductAiModal } from "../../components/Modals/ProductAi"
import { Toast } from "../../utils/Toast"
import { ProductContext } from "../../context/ProductContext"
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai"
import { MenuContext } from "../../context/MenuContext"
import { GlobalContext } from "../../context/GlobalContext"
import { maskCurrency } from "../../utils/utils"
import { DateTime } from "luxon"
import "../admin.css"
import "./style.css"

export function ProductPage() {
  const [searchParams] = useSearchParams()
  const editId = searchParams.get("edit")
  const { isAccess } = useContext(GlobalContext)
  const { findAllCategory, setCategoryId } = useContext(MenuContext)
  const { setProductEdit, productEdit } = useContext(ProductContext)
  const [products, setProducts] = useState([])

  const [search, setSearch] = useState('')

  const [orderBy, setOrderby] = useState({
    field: 'name',
    order: 'asc'
  })

  useEffect(() => {
    findAll()
    findAllCategory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!editId) return;
    let cancelled = false;
    api.get('/products').then(({ data }) => {
      const product = data.data.find((item) => item.id === editId);
      if (!cancelled && product) setProductEdit(product);
      if (!cancelled && !product) Toast.warning('Produto não encontrado para revisão.');
    }).catch(() => Toast.warning('Não foi possível abrir o produto para revisão.'));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editId]);

  async function findAll() {
    const response = await api.get('/products')
    const { data: { data } } = response
    setProducts(data)
  }

  async function destroy(id) {
    const confirmation = await Toast.confirm()
    if (confirmation) {
      await api.delete('/products/' + id)
      setProducts(products.filter(e => e.id !== id))
      Toast.warning("Produto deletado com sucesso")
    }
  }

  async function onChange(id, key, value) {
    if (!isAccess('produtos', 'update')) {
      Toast.warning('Você não tem permissão para atualizar')
      return
    }


    const oldState = [...products]
    setProducts(products.map(e => {
      if (e.id === id) {
        return {
          ...e,
          [key]: value
        }
      }
      return e
    }))

    await api.put(`/products/${id}`, {
      [key]: value
    }).catch(() => {
      setProducts(oldState)
    })

    Toast.success('Registro atualizado')
  }

  useEffect(() => {
    if (productEdit.id) {
      const myModal = new window.bootstrap.Modal(document.getElementById('modalProduct'), {})
      myModal.toggle()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productEdit.id])

  function changeOrder(field) {
    setOrderby((current) => ({
      field,
      order: current.field === field && current.order === 'asc' ? 'desc' : 'asc'
    }))
  }

  const displayedProducts = _.orderBy(products, (product) => product[orderBy.field], orderBy.order)
    .filter((product) => !search || String(product.name).toLowerCase().includes(search.toLowerCase()))

  return (
    <>
      <ProductModal isLocal={true} isMenu={false} loadProducts={() => findAll()} />
      <ProductAiModal isLocal={true} isMenu={false} loadProducts={() => findAll()} />
      <NavBar>
        <main className="admin-page product-page">
          <header className="admin-page-header"><div><h1>Produtos</h1><p>Gerencie preços, disponibilidade e canais de venda</p></div>
            {isAccess('produtos', 'create') && (
              <div className="admin-header-actions">
                <button className="admin-secondary-button" data-bs-toggle="modal" data-bs-target="#modalProductAi" onClick={() => setCategoryId('')}><FiZap /> Criar com IA</button>
                <button className="admin-primary-button" data-bs-toggle="modal" data-bs-target="#modalProduct"><FiPlus /> Novo produto</button>
              </div>
            )}</header>

          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>Produtos cadastrados</h2><p>{displayedProducts.length} de {products.length} produtos</p></div><FiBox size={19} /></div>
            <div className="admin-filter-bar"><label><span>Pesquisar produto</span><div className="product-search"><FiSearch /><input type="search" placeholder="Digite o nome do produto" onChange={(e) => setSearch(e.target.value)} value={search} /></div></label></div>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th><button className="product-sort" onClick={() => changeOrder('name')}>
                    Nome {orderBy.field === 'name' && (orderBy.order === 'asc' ? <AiOutlineArrowDown /> : <AiOutlineArrowUp />)}
                  </button>
                  </th>
                  <th>Criado em</th>
                  <th>Tipo</th>
                  <th><button className="product-sort" onClick={() => changeOrder('active')}>
                    Status {orderBy.field === 'active' && (orderBy.order === 'asc' ? <AiOutlineArrowDown /> : <AiOutlineArrowUp />)}
                  </button>
                  </th>
                  <th>Preço</th>
                  <th >Ações</th>
                </tr>
              </thead>
              <tbody>
                {displayedProducts.map((product) => {
                  return (
                    <tr key={product.id}>
                      <td data-label="Nome"><strong>{product.name}</strong>{product.codReferencia && <small className="product-reference">Ref. {product.codReferencia}</small>}</td>
                      <td data-label="Criado em">{DateTime.fromISO(product.createdAt).toFormat('dd/MM/yyyy HH:mm')}</td>
                      <td data-label="Tipo"><div className="product-channels">
                        {Boolean(product.isMenu) && (<span>Delivery</span>)}
                        {Boolean(product.isLocal) && (<span>Venda local</span>)}
                      </div>
                      </td>
                      <td data-label="Status">
                        <label className="admin-toggle" aria-label={`${product.active ? 'Desativar' : 'Ativar'} ${product.name}`}><input onChange={(e) => onChange(product.id, 'active', e.target.checked)} type="checkbox" checked={Boolean(product.active)} /><span /></label>
                      </td>
                      <td data-label="Preço"><strong>{maskCurrency(product.pricing)}</strong>
                      </td>
                      <td data-label="Ações">
                        {(isAccess('produtos', 'update') || isAccess('produtos', 'delete')) && (
                          <div className="product-actions">
                            {isAccess('produtos', 'update') && <button className="admin-icon-button" onClick={() => setProductEdit(product)} aria-label={`Editar ${product.name}`}><FiEdit2 /></button>}
                            {isAccess('produtos', 'delete') && <button className="admin-icon-button danger" onClick={() => destroy(product.id)} aria-label={`Excluir ${product.name}`}><FiTrash2 /></button>}
                          </div>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          {displayedProducts.length === 0 && <div className="admin-empty"><FiBox size={25} /><strong>Nenhum produto encontrado</strong><span>{search ? 'Ajuste a pesquisa e tente novamente.' : 'Cadastre o primeiro produto para começar.'}</span></div>}
          </section>
        </main>
      </NavBar>
    </>
  )
}


